"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newLetterFormSchema = void 0;
const Yup = require("yup");
exports.newLetterFormSchema = Yup.object({
    email: Yup.string()
        .required('Email is a required field')
        .email('You must enter a valid email')
        .max(60, 'Email must be less than 60 characters'),
});
